import { useLocation, useParams } from 'react-router-dom';
import { OracleResult } from '../types/oracle';

export default function Result() {
  const location = useLocation();
  const { id } = useParams<{ id: string }>();
  let result = location.state?.result as OracleResult;
  if (!result && id) {
    const stored = localStorage.getItem(`quizmatron_result_${id}`);
    if (stored) {
      result = JSON.parse(stored);
    }
  }

  if (!result || result.type !== 'result') {
    return <div className="error">Invalid result data</div>;
  }

  return (
    <div className="result">
      <h1>{result.success ? 'Success!' : 'Analysis Complete'}</h1>
      <p>{result.message}</p>
      <button 
        className="back-button"
        onClick={() => window.location.href = '/'}
      >
        Start Over
      </button>
    </div>
  );
}
